export function getConfig() {
  return {
    domain: process.env.REACT_APP_AUTH_DOMAIN ,
    clientId: process.env.REACT_APP_AUTH_CLIENTID,
    audience:process.env.REACT_APP_AUTH_AUDIENCE,
    bff_web_URL: process.env.REACT_APP_BFF_WEB_URL,
    env: process.env.REACT_APP_STAGE
  };
}